import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { isNode } from "@azure/core-http";
import * as os from "os";
import { TelemetryPolicy } from "./policies/TelemetryPolicy";
import { SDK_VERSION } from "./utils/constants";
/**
 * TelemetryPolicyFactory is a factory class helping generating {@link TelemetryPolicy} objects.
 */

export var TelemetryPolicyFactory = /*#__PURE__*/function () {
  /**
   * Creates an instance of TelemetryPolicyFactory.
   * @param telemetry -
   */
  function TelemetryPolicyFactory(telemetry) {
    _classCallCheck(this, TelemetryPolicyFactory);

    var userAgentInfo = [];

    if (isNode) {
      if (telemetry) {
        var telemetryString = telemetry.userAgentPrefix || "";

        if (telemetryString.length > 0 && userAgentInfo.indexOf(telemetryString) === -1) {
          userAgentInfo.push(telemetryString);
        }
      } // e.g. azsdk-js-storageblob/10.0.0


      var libInfo = "azsdk-js-storageblob/".concat(SDK_VERSION);

      if (userAgentInfo.indexOf(libInfo) === -1) {
        userAgentInfo.push(libInfo);
      } // e.g. (NODE-VERSION 4.9.1; Windows_NT 10.0.16299)


      var runtimeInfo = "(NODE-VERSION ".concat(process.version, "; ").concat(os.type(), " ").concat(os.release(), ")");

      if (userAgentInfo.indexOf(runtimeInfo) === -1) {
        userAgentInfo.push(runtimeInfo);
      }
    }

    this.telemetryString = userAgentInfo.join(" ");
  }
  /**
   * Creates a TelemetryPolicy object.
   *
   * @param nextPolicy -
   * @param options -
   */


  _createClass(TelemetryPolicyFactory, [{
    key: "create",
    value: function create(nextPolicy, options) {
      return new TelemetryPolicy(nextPolicy, options, this.telemetryString);
    }
  }]);

  return TelemetryPolicyFactory;
}();